import { render } from "./Registration3Env.vue?vue&type=template&id=f5e7fe9c"
import script from "./Registration3Env.vue?vue&type=script&lang=js"
export * from "./Registration3Env.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
